/*
    Autogenerated class model from django Note
    -- 2023-03-13 18:02:20.828573
*/
import Vue from 'vue';

// BaseObjectClass defines methods load, save, delete
import { BaseObjectClass, BaseCollection, BaseStoreCollection } from '@/base_object_class';

class NoteClass extends BaseObjectClass {
    constructor(rawData = {}) {
        super();
        this.populate(rawData);
    }

    populate(rawData = {}) {
        Vue.set(this, 'isLoading', false);
        Vue.set(this, 'pk', rawData.pk || null);
        Vue.set(this, 'id', rawData.pk || null);
        Vue.set(this, 'createdAt', new Date(rawData.createdAt));
        Vue.set(this, 'updatedAt', new Date(rawData.updatedAt));

        /* Define default values here if needed */
        Vue.set(this, 'professional', rawData.professional);
        Vue.set(this, 'creator', rawData.creator);
        Vue.set(this, 'note', rawData.note || '');
        Vue.set(this, 'pinned', rawData.pinned || false);
    }

    getBaseUrl() {
        return '/listepro/note/';
    }

    get isValid() {
        return true;
    }
}

class NoteCollection extends BaseCollection {
    initModel(rawData) {
        return new NoteClass(rawData);
    }

    getBaseUrl() {
        return '/listepro/note/';
    }
}

class NoteStoreCollection extends BaseStoreCollection {
    initModel(rawData) {
        return new NoteClass(rawData);
    }

    getBaseUrl() {
        return '/listepro/note/';
    }

    getStorePath() {
        return 'listepro/noteCollection';
    }
}

export {
    NoteClass,
    NoteCollection,
    NoteStoreCollection,
};
